// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"archway"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 21V9H20V21H4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M5 4H19L20 9H4L5 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19 4H5M19 4L20 9M19 4H20M19 4V3M5 4L4 9M5 4H4M5 4V3M4 9V21M4 9H3M4 9H9M4 21H3M4 21H9M20 9V21M20 9H21M20 9H15M20 21H21M20 21H15M9 21V9M9 21H15M9 9H15M15 9V21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-archway')
export default class ArchwayIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'archway',
    }
  }
}
